var gvUrl=window.gvUrl||(window.gvUrl=function(p){var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';return r+String(p).replace(/^\//,'')});
class Headerjs extends HTMLElement {
  constructor() {
    super();
    this.hideThreshold = 320;
    this.showThreshold = 150;
    this.lastScrollY = 0;
    this.downDistance = 0;
    this.upDistance = 0;
    this.isHeaderHidden = false;

    this.sectionEl = null;
    this.announcementEl = null;
    this.stickyBottom = null;
    this.overlay = null;
    this.drawerMenu = null;
    this.openDrawerTrigger = null;
    this.closeDrawerTrigger = null;
    this.anchorLinkListeners = [];
    this.drawerLinkListeners = [];

    this.handleResize = this.handleResize.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.updateCartCount = this.updateCartCount.bind(this);
    this.handleOpenDrawer = this.handleOpenDrawer.bind(this);
    this.handleCloseDrawer = this.handleCloseDrawer.bind(this);
  }

  connectedCallback() {
    this.sectionEl = this.closest('header[data-section-type="w-header"]');
    this.announcementEl = document.querySelector('[data-section-type="w-announcement"]');
    this.stickyBottom = this.sectionEl ? this.sectionEl.querySelector('sticky-bottom') : document.querySelector('sticky-bottom');
    this.overlay = this.querySelector('[data-overlay]');
    this.drawerMenu = this.querySelector('.header__content-left');
    this.openDrawerTrigger = this.querySelector('[data-open-drawer-menu]');
    this.closeDrawerTrigger = this.querySelector('.header-content-left__drawer-header-title');

    this.bindAnchorLinks();
    this.bindDrawerLinks();

    if (this.openDrawerTrigger) {
      this.openDrawerTrigger.addEventListener('click', this.handleOpenDrawer);
    }

    if (this.closeDrawerTrigger) {
      this.closeDrawerTrigger.addEventListener('click', this.handleCloseDrawer);
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', this.handleCloseDrawer);
    }

    document.addEventListener('cart:updated', this.updateCartCount);

    this.lastScrollY = Math.max(window.scrollY || 0, 0);
    this.updateHeaderHeight();
    this.updateHeaderTopOffset(true);
    this.updateStickyBottom(this.lastScrollY);
    this.showHeader(true);

    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll, { passive: true });

    this.updateCartCount();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('cart:updated', this.updateCartCount);

    if (this.openDrawerTrigger) {
      this.openDrawerTrigger.removeEventListener('click', this.handleOpenDrawer);
    }

    if (this.closeDrawerTrigger) {
      this.closeDrawerTrigger.removeEventListener('click', this.handleCloseDrawer);
    }

    if (this.overlay) {
      this.overlay.removeEventListener('click', this.handleCloseDrawer);
    }

    this.anchorLinkListeners.forEach(({ link, handler }) => {
      link.removeEventListener('click', handler);
    });

    this.drawerLinkListeners.forEach(({ link, handler }) => {
      link.removeEventListener('click', handler);
    });

    this.anchorLinkListeners = [];
    this.drawerLinkListeners = [];
  }

  bindAnchorLinks() {
    document.querySelectorAll('a[href^="#"]').forEach((link) => {
      const handler = (event) => {
        const href = link.getAttribute('href');
        if (!href || href === '#') {
          return;
        }

        let target;
        try {
          target = document.querySelector(href);
        } catch {
          return;
        }
        if (!target) {
          return;
        }

        event.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
        this.closeDrawerMenu();
      };

      link.addEventListener('click', handler);
      this.anchorLinkListeners.push({ link, handler });
    });
  }

  bindDrawerLinks() {
    this.querySelectorAll('.header__content-left a').forEach((link) => {
      const handler = () => {
        this.closeDrawerMenu();
      };

      link.addEventListener('click', handler);
      this.drawerLinkListeners.push({ link, handler });
    });
  }

  handleResize() {
    this.updateHeaderHeight();
    this.updateHeaderTopOffset(true);
  }

  handleScroll() {
    const currentY = Math.max(window.scrollY || 0, 0);
    this.updateHeaderTopOffset();
    this.updateStickyBottom(currentY);
    this.updateSmartHeader(currentY);
  }

  handleOpenDrawer() {
    this.openDrawerMenu();
  }

  handleCloseDrawer() {
    this.closeDrawerMenu();
  }

  openDrawerMenu() {
    if (!this.drawerMenu) {
      return;
    }

    if (this.drawerMenu.classList.contains('open')) {
      this.drawerMenu.classList.remove('open');
      if (this.overlay) {
        this.overlay.classList.remove('open');
      }
      document.body.classList.remove('overflow-hidden');
      return;
    }

    this.drawerMenu.classList.add('open');
    if (this.overlay) {
      this.overlay.classList.add('open');
    }
    document.body.classList.add('overflow-hidden');
  }

  closeDrawerMenu() {
    if (!this.drawerMenu) {
      return;
    }

    this.drawerMenu.classList.remove('open');
    if (this.overlay) {
      this.overlay.classList.remove('open');
    }
    document.body.classList.remove('overflow-hidden');
  }

  updateHeaderHeight() {
    if (!this.sectionEl) {
      return;
    }

    const height = Math.round(this.getBoundingClientRect().height);
    this.sectionEl.style.setProperty('--w-header-height', `${height}px`);
  }

  updateHeaderTopOffset(force = false) {
    if (!this.sectionEl) {
      return;
    }

    if (this.isHeaderHidden && !force) {
      return;
    }

    let offset = 0;

    if (this.announcementEl) {
      const rect = this.announcementEl.getBoundingClientRect();
      offset = Math.max(0, Math.min(rect.bottom, rect.height));
    }

    this.sectionEl.style.setProperty('--w-header-top-offset', `${offset}px`);
  }

  updateStickyBottom(scrollY) {
    if (!this.stickyBottom) {
      return;
    }

    if (scrollY > 200) {
      this.stickyBottom.classList.add('active');
      return;
    }

    this.stickyBottom.classList.remove('active');
  }

  updateSmartHeader(currentY) {
    if (currentY <= 0) {
      this.showHeader();
      this.resetScrollState(0);
      return;
    }

    const delta = currentY - this.lastScrollY;

    if (delta > 0) {
      this.downDistance += delta;
      this.upDistance = 0;

      if (!this.isHeaderHidden && currentY >= this.hideThreshold && this.downDistance >= this.hideThreshold) {
        this.hideHeader();
        this.downDistance = 0;
      }
    } else if (delta < 0) {
      this.upDistance += Math.abs(delta);
      this.downDistance = 0;

      if (this.isHeaderHidden && this.upDistance >= this.showThreshold) {
        this.showHeader();
        this.upDistance = 0;
      }
    }

    this.lastScrollY = currentY;
  }

  resetScrollState(scrollY) {
    this.lastScrollY = scrollY;
    this.downDistance = 0;
    this.upDistance = 0;
  }

  showHeader(force = false) {
    if (!force && !this.isHeaderHidden) {
      return;
    }

    this.classList.remove('w-header--hidden');
    this.isHeaderHidden = false;
    this.updateHeaderTopOffset(true);
  }

  hideHeader() {
    if (this.isHeaderHidden) {
      return;
    }

    this.classList.add('w-header--hidden');
    this.isHeaderHidden = true;
  }

  async updateCartCount() {
    try {
      const response = await fetch(gvUrl('/cart.js'), {
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) {
        return;
      }

      const cart = await response.json();
      const countEl = this.querySelector('.header__content-right-cart-count');
      if (!countEl) {
        return;
      }

      countEl.textContent = cart.item_count;
      countEl.style.display = cart.item_count > 0 ? '' : 'none';
    } catch {
    }
  }
}

if (!customElements.get('header-js')) {
  customElements.define('header-js', Headerjs);
}
